var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
export const RangeInput = forwardRef((_a, ref) => {
    var { label, type, value = 0, isInvalid } = _a, rest = __rest(_a, ["label", "type", "value", "isInvalid"]);
    return (_jsxs(_Fragment, { children: [_jsxs(Form.Label, Object.assign({ className: 'w-100', htmlFor: rest.name }, { children: [label, ' '] })), _jsxs(Row, { children: [_jsx(Col, Object.assign({ md: 9 }, { children: _jsx(Form.Range, Object.assign({ className: `custom-range w-100 ${isInvalid ? 'field-error' : ''}` }, rest, { id: rest.name, ref: ref, value: value || 0 })) })), _jsx(Col, Object.assign({ md: 3, className: 'text-right' }, { children: _jsx("div", { children: value || '0' }) }))] })] }));
});
RangeInput.displayName = 'RangeInput';
